import React, { useState, useRef, useEffect } from 'react';

const SortDropdown = ({ value, onChange, options, testId }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = options.find(o => o.value === value);

  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 h-9 px-3 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 whitespace-nowrap"
        data-testid={testId || 'sort-dropdown'}>
        <svg className="w-3.5 h-3.5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" /></svg>
        <span className="text-gray-700">{current?.label || 'Sort'}</span>
        <svg className={`w-3 h-3 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {open && (
        <div className="absolute z-50 top-full right-0 mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl min-w-[180px] py-1" data-testid={`${testId || 'sort'}-options`}>
          {options.map(opt => (
            <button key={opt.value} type="button"
              className={`w-full text-left px-3 py-1.5 text-sm hover:bg-blue-50 flex items-center gap-2 ${value === opt.value ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'}`}
              onClick={() => { onChange(opt.value); setOpen(false); }}>
              {opt.icon && <span className="text-xs text-gray-400">{opt.icon}</span>}
              {opt.label}
              {value === opt.value && <svg className="w-3.5 h-3.5 ml-auto text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
